<template>
    <div>
        <vue-dropzone
            v-if="editable" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
            v-on:vdropzone-removed-file="removeThisFile"
            v-on:vdropzone-complete="fileUploaded"
            v-on:vdropzone-file-added="update_cookie"
        >
        </vue-dropzone>
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {EventBus} from "../mixins/event-bus";
import ShowNotification from "../mixins/show-notification";

export default {
    name: 'dropzone',
    props: {
        route_store: {
            type: String
        },
        route_delete: {
            type: String
        },
        editable: {
            type: Boolean,
            default: true
        },
        prevent_duplicates: {
            type: Boolean,
            default: false
        },
        max_files: {
            type: Number|null,
            default: null
        },
        accepted_files: {
            type: String|null,
            default: null
        },
        event_prefix: {
            type: String,
            required: false,
            default: ''
        }
    },
    components: {
        vueDropzone: vue2Dropzone
    },
    mixins: [ShowNotification],
    data: function () {
        return {
            dropzoneOptions: {
                url: this.route_store,
                maxFilesize: 5,
                uploadMultiple: true,
                parallelUploads: 5,
                addRemoveLinks: true,
                headers: {
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                },
                dictDefaultMessage: this.$lang('Kliknij, aby wybrać plik lub przeciągnij go tutaj'),
                dictFileTooBig: this.$lang('Maksymalny rozmiar: {{maxFilesize}}MiB.'),
                dictInvalidFileType: this.$lang('Nie możesz przesłać plików tego typu'),
                dictResponseError: this.$lang('Odpowiedz serwera {{statusCode}}'),
                dictCancelUpload: this.$lang('Anuluj'),
                dictUploadCanceled: this.$lang('Wysyłanie anulowane'),
                dictCancelUploadConfirmation: this.$lang('Jesteś pewien, że chcesz anulować to wysyłanie?'),
                dictRemoveFile: this.$lang('Usuń'),
                dictMaxFilesExceeded: this.$lang('Nie możesz wysłać więcej plików'),
                maxFiles: this.max_files,
                acceptedFiles: this.accepted_files,
            },
            prevTemplate: ''
        }
    },
    methods: {
        removeThisFile(file) {
            this.update_cookie();
            let name = file.name;
            axios.post(this.route_delete, {name: name,});
            this.updateCounter();
            EventBus.$emit(this.event_prefix+'dropzone-removed-file', {file});
        },
        fileDuplicated(file) {
            EventBus.$emit(this.event_prefix+'dropzone-duplicated', file.name);
        },
        fileUploaded(file) {
            EventBus.$emit(this.event_prefix+'dropzone-complete', {file});
        },
        update_cookie() {
            document.cookie = "tabID = " + sessionStorage.getItem("tabID") + "; path=/;";
            this.updateCounter();
        },
        updateCounter() {
            if (this.$refs.myVueDropzone) {
                let counter = Number(this.$refs.myVueDropzone.dropzone.files.length);
                sessionStorage.setItem('filesCounter', counter);
            }
        },
        listenForRemoveFileRequest() {
            EventBus.$on(this.event_prefix+'dropzone-remove-file', (file) => {
                this.$refs.myVueDropzone.dropzone.removeFile(file);
            });
        }
    },
    mounted() {
        this.updateCounter();
        this.listenForRemoveFileRequest();
        let iPageTabID = Number(sessionStorage.getItem("tabID"));
        // if it is the first time that this page is loaded
        if (iPageTabID === 0) {
            let iLocalTabID = Number(localStorage.getItem("tabID"));
            // if tabID is not yet defined in localStorage it is initialized to 1
            // else tabId counter is increment by 1
            let iPageTabID = (iLocalTabID == null) ? 1 : Number(iLocalTabID) + 1;
            // new computed value are saved in localStorage and in sessionStorage
            localStorage.setItem("tabID", iPageTabID);
            sessionStorage.setItem("tabID", iPageTabID);
            document.cookie = "tabID = " + sessionStorage.getItem('tabID') + "; path=/;";
        }

        this.$refs.myVueDropzone.dropzone.on("addedfile", file => {
            if (file.name.length > 180) {
                this.showNotification('error', this.$lang('Zbyt długa nazwa pliku. Powinna być ona krótsza niż 180 znaków.'));
                this.$refs.myVueDropzone.dropzone.removeFile(file);
                this.updateCounter();
            }
        });

        if (this.prevent_duplicates && this.$refs.myVueDropzone !== undefined) {
            this.$refs.myVueDropzone.dropzone.on("addedfile", file => {
                if (this.$refs.myVueDropzone.dropzone.files.length) {
                    let i, len;
                    for (
                        i = 0, len = this.$refs.myVueDropzone.dropzone.files.length;
                        i < len - 1; // -1 to exclude current file
                        i++
                    ) {
                        if (this.$refs.myVueDropzone.dropzone.files[i].name === file.name) {
                            // cookie for skip deleting file
                            document.cookie = "duplicate = true";
                            localStorage.setItem("duplicate", "true");
                            sessionStorage.setItem("duplicate", "true");
                            this.$refs.myVueDropzone.dropzone.removeFile(file);
                            this.updateCounter();
                            EventBus.$emit(this.event_prefix+'dropzone-duplicated', file.name);
                        }
                    }
                }
            });
        }
    }
}
</script>
